@if (loaded) {
  @if (localizedImages$ | async; as localizedImages) {
    <section class="hero-wrapper relative" [class.m-t-9]="!localizedImages.banner">
      @if (localizedImages.banner) {
        <img
          class="w-full h-full"
          [class.pointer-events-none]="!operatorSettings?.bannerLink"
          [class.cursor-pointer]="operatorSettings?.bannerLink"
          [alt]="'a11y.home.banner.image' | translate"
          [src]="localizedImages.banner"
          (click)="goToUrl($event, operatorSettings?.bannerLink)"
        />

        @if (operatorSettings?.bannerLink) {
          <a
            class="block"
            target="_blank"
            [attr.aria-label]="'a11y.home.banner.url' | translate"
            [href]="operatorSettings?.bannerLink"
          >
          </a>
        }
      }

      <div
        class="flex flex-column text-center w-full gap-2 sm:gap-3"
        [ngClass]="{ 'translate-hero-wrapper-title absolute top-50 left-50 text-white': localizedImages.banner }"
      >
        @if ('home.exhibition-title' | translate | hideTranslation; as homeExhibitionTitle) {
          <h1
            class="event-selection-heading font-normal text-xl line-height-1 p-x-6 md:text-4xl lg:text-6xl"
            data-translation="home.exhibition-title"
            [innerHTML]="homeExhibitionTitle"
          ></h1>
        }

        @if ('home.exhibition-subtitle' | translate | hideTranslation; as homeExhibitionSubtitle) {
          <h2
            class="event-selection-subheading font-size-7 font-normal text-sm line-height-2 w-auto m-auto p-x-6 sm:text-base md:w-6 md:text-lg lg:text-xl"
            data-translation="home.exhibition-subtitle"
            [innerHTML]="homeExhibitionSubtitle"
          ></h2>
        }
      </div>
    </section>

    <section
      class="container m-b-9"
      [ngClass]="{
        'm-t-9': !localizedImages.banner,
        '-m-t-9 sm:-m-t-15': localizedImages.banner
      }"
    >
      <ls-grid>
        <ls-row>
          @for (exhibition of exhibitions; track $index) {
            @if ((exhibition.isVisible && !exhibition.isOver) || (isLoggedInAsAdmin$ | async)) {
              <ls-col class="relative p-4" [xs]="12" [sm]="6" [md]="4" [lg]="3">
                @if (exhibition.ageRating) {
                  <app-age-rating [rating]="exhibition.ageRating" [adjustPositions]="{ top: '20px', right: '20px' }" />
                }

                @if (exhibition) {
                  <app-exhibition-card
                    class="cursor-pointer"
                    [exhibition]="exhibition"
                    (click)="navigateToExhibition($event, exhibition.id)"
                  />
                }
              </ls-col>
            }
          }
        </ls-row>
      </ls-grid>
    </section>
  }
} @else {
  <app-loader />
}
